import i18n from 'modules/core/lib/i18n'

import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

export interface StatusCounts {
  draft?: number
  pending?: number
  approved?: number
  paid?: number
}

interface UseDataCollectionConfigOptions {
  includeDraft?: boolean
  statusCounts?: StatusCounts
  showDateNavigation?: boolean
}

const emptyNavigationFilters: Record<string, never> = {}

export const useDataCollectionConfig = (options: UseDataCollectionConfigOptions = {}) => {
  const { includeDraft = true, statusCounts, showDateNavigation = true } = options
  const { dateFilters } = usePageDateFilters()

  const navigationFilters = showDateNavigation
    ? {
        date: {
          defaultGranularity: 'range' as const,
          defaultValue: {
            from: dateFilters.startDate,
            to: dateFilters.endDate,
          },
          granularity: ['day', 'week', 'month', 'year', 'range'],
          type: 'date-navigator' as const,
        },
      }
    : emptyNavigationFilters

  const presets = [
    ...(includeDraft
      ? [
          {
            label: i18n.t('expenses_v2.expense.status.draft'),
            filter: { status: ['draft'] },
            itemsCount: () => statusCounts?.draft,
          },
        ]
      : []),
    {
      label: i18n.t('expenses_v2.expense.status.pending'),
      filter: { status: ['pending'] },
      itemsCount: () => statusCounts?.pending,
    },
    {
      label: i18n.t('expenses_v2.expense.status.approved'),
      filter: { status: ['approved'] },
      itemsCount: () => statusCounts?.approved,
    },
    {
      label: i18n.t('expenses_v2.expense.status.paid'),
      filter: { status: ['in_payroll', 'sent_to_pay', 'paid'] },
      itemsCount: () => statusCounts?.paid,
    },
  ]

  return { navigationFilters, presets }
}
